<template>
  <div>
    <div class="content-i">
      <div class="content-box" v-if="layout == 'app-layout'">
        <!--div class="row">
          <div class="col-sm-12">
            <div class="element-wrapper">
              <h6 class="element-header">Sales Dashboard</h6>
              <div class="element-content">
                <div class="row">
                  <div class="col-sm-4 col-xxxl-3">
                    <a class="element-box el-tablo" href="#">
                      <div class="label">Products Sold</div>
                      <div class="value">57</div>
                      <div class="trending trending-up-basic">
                        <span>12%</span
                        ><i class="os-icon os-icon-arrow-up2"></i>
                      </div>
                    </a>
                  </div>
                  <div class="col-sm-4 col-xxxl-3">
                    <a class="element-box el-tablo" href="#">
                      <div class="label">Gross Profit</div>
                      <div class="value">$457</div>
                      <div class="trending trending-down-basic">
                        <span>12%</span
                        ><i class="os-icon os-icon-arrow-down"></i>
                      </div>
                    </a>
                  </div>
                  <div class="col-sm-4 col-xxxl-3">
                    <a class="element-box el-tablo" href="#">
                      <div class="label">New Customers</div>
                      <div class="value">125</div>
                      <div class="trending trending-down-basic">
                        <span>9%</span
                        ><i class="os-icon os-icon-arrow-down"></i>
                      </div>
                    </a>
                  </div>
                  <div class="d-none d-xxxl-block col-xxxl-3">
                    <a class="element-box el-tablo" href="#">
                      <div class="label">Refunds Processed</div>
                      <div class="value">$294</div>
                      <div class="trending trending-up-basic">
                        <span>12%</span
                        ><i class="os-icon os-icon-arrow-up2"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div-->

        <div class="row" v-if="cashflow_cortes_caja.length > 0">
          <div class="col-sm-6">
            <div class="alert alert-danger" role="alert">
              <h4 class="alert-heading">¡ ATENCION !</h4>
              <p>
                El Máximo de efectivo permitido por caja ya fue superado por los
                siguientes usuarios, favor iniciar el proceso de retiro.
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <table class="table table-lightborder">
              <thead>
                <tr>
                  <th>Tienda</th>
                  <th>Caja</th>
                  <th>Usuario</th>
                  <th>Apertura</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="caja in cashflow_cortes_caja" :key="caja.id">
                  <td>
                    {{ caja.nombre_tienda }}
                  </td>
                  <td>
                    {{ caja.caja }}
                  </td>
                  <td>
                    {{ caja.cajero }}
                  </td>
                  <td>
                    {{ caja.fecha_apertura | formatFechaHora }}
                  </td>
                  <td class="text-center">
                    <div
                      class="status-pill red"
                      data-title="Cancelled"
                      data-toggle="tooltip"
                      data-original-title=""
                      title=""
                    ></div>
                    Retiro de Efectivo Requerido
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5" v-if="mostrar_checklist">
            <CheckListComponent :user_profile="user_profile" />
          </div>
          <div
            :class="{
              'col-sm-7': mostrar_checklist,
              'col-sm-12': mostrar_checklist == false,
            }"
          >
            <div class="element-wrapper">
              <h6 class="element-header">Ultimos contenedores</h6>
              <div class="element-box-tp">
                <div class="table-responsive">
                  <table
                    class="table table-bordered table-lg table-v2 table-striped"
                  >
                    <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th>Encargado</th>
                        <th>Inicio Carga</th>
                        <th>Fin Carga</th>
                        <th>Salida</th>
                        <th>Llegada</th>
                        <th>Retorno</th>
                        <th>Piloto</th>
                        <th>Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="contenedor in contenedores"
                        :key="contenedor.id"
                      >
                        <td class="text-center">
                          {{ contenedor.numero }}
                        </td>
                        <td>
                          <UsuarioEnTablaComponent
                            :current="contenedor.encargado_obj"
                          />
                        </td>
                        <td>
                          {{ contenedor.fecha_inicio_carga | formatFechaHora }}
                        </td>
                        <td>
                          {{ contenedor.fecha_fin_carga | formatFechaHora }}
                        </td>
                        <td>
                          {{ contenedor.fecha_salida | formatFechaHora }}
                        </td>
                        <td>
                          {{ contenedor.fecha_llegada | formatFechaHora }}
                        </td>
                        <td>
                          {{ contenedor.fecha_retorno | formatFechaHora }}
                        </td>
                        <td class="text-center">
                          {{ contenedor.piloto }}
                        </td>
                        <td class="text-center">
                          {{ contenedor.estado_str }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-xxxl-12">
            <div class="element-wrapper">
              <h6 class="element-header">Inventarios Negativos</h6>
              <div class="element-box">
                <div class="table-responsive">
                  <table class="table table-lightborder">
                    <thead>
                      <tr>
                        <th>Producto</th>
                        <th>Tienda</th>
                        <th>Mínimo</th>
                        <th>Máximo</th>
                        <th>Ultimo Ajuste</th>
                        <th class="text-right">Inventario</th>
                        <th class="text-right"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="negativo in negativos">
                        <td class="nowrap">
                          <router-link
                            :to="'/cat/productos/editar/' + negativo.sku"
                            v-html="negativo.sku"
                          >
                          </router-link>
                          - {{ negativo.nombre }}
                        </td>
                        <td>
                          {{ negativo.tienda_nombre }}
                        </td>
                        <td>
                          {{ negativo.minimo }}
                        </td>
                        <td>
                          {{ negativo.maximo }}
                        </td>
                        <td>
                          {{ negativo.fecha_ultimo_ajuste }}
                        </td>
                        <td class="text-right">
                          {{ negativo.existencia }}
                        </td>
                        <td class="text-right">
                          <router-link
                            :class="'btn btn-success btn-sm'"
                            :to="
                              '/inventario/reportes/kardex/' +
                              negativo.sku +
                              '/' +
                              negativo.tienda_id +
                              '/'
                            "
                            v-html="'Kardex'"
                          >
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-box" v-if="layout == 'hh-layout'">
        <DashboardHHComponent />
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import CheckListComponent from "@/components/commons/CheckListComponent";
import DashboardHHComponent from "@/components/DashboardHHComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    UsuarioEnTablaComponent,
    CheckListComponent,
    DashboardHHComponent,
  },
  data() {
    return {
      contenedores: [],
      negativos: [],
      cashflow_cortes_caja: [],
      user_profile: {
        checklist: [],
      },
    };
  },
  props: {},
  watch: {},
  computed: {
    mostrar_checklist() {
      return this.user_profile.checklist.length > 0;
    },
    layout() {
      return this.$store.getters.layout;
    },
  },
  mounted() {
    let self = this;
    self.refreshProfile();
    if (self.layout != "hh-layout") {
      self.refreshContenedores();
      self.refreshNegativos();
      self.refreshCashFlowCajas();
    }
  },
  methods: {
    refreshContenedores() {
      let self = this;
      DynamicService.getActionList(
        "dashboard",
        "dashboard-user",
        "ultimos_contenedores"
      ).then((response) => {
        self.contenedores = response.data;
      });
    },
    refreshNegativos() {
      let self = this;
      DynamicService.getActionList(
        "dashboard",
        "dashboard-user",
        "negativos"
      ).then((response) => {
        self.negativos = response.data;
      });
    },
    refreshProfile: function () {
      let self = this;
      DynamicService.getActionList(
        "dashboard",
        "dashboard-user",
        "checklist"
      ).then((response) => {
        self.user_profile = response.data;
      });
    },
    refreshCashFlowCajas: function () {
      let self = this;
      DynamicService.getActionList(
        "dashboard",
        "dashboard-user",
        "cashflow_cortes_caja"
      ).then((response) => {
        self.cashflow_cortes_caja = response.data;
      });
    },
  },
};
</script>

